// Markaziy sana formatlash — butun tizimda yagona DD.MM.YYYY (sana) va
// DD.MM.YYYY HH:mm (sana+vaqt) ko'rinishi. Locale'dan qat'i nazar nuqtali format.
const pad = (n) => String(n).padStart(2, '0');

export function formatDate(d) {
  if (!d) return '—';
  const x = new Date(d);
  if (isNaN(x.getTime())) return '—';
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
}

export function formatDateTime(d) {
  if (!d) return '—';
  const x = new Date(d);
  if (isNaN(x.getTime())) return '—';
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()} ${pad(x.getHours())}:${pad(x.getMinutes())}`;
}

// ISO/Date -> "YYYY-MM-DDTHH:mm" (foydalanuvchining mahalliy vaqti bo'yicha) —
// <input type="datetime-local">'ning value'i uchun. Aksincha yo'nalish uchun
// oddiy `new Date(inputValue).toISOString()` yetarli — brauzer bu qatorni
// avtomatik mahalliy vaqt deb o'qiydi.
export function toDateTimeInputValue(d) {
  if (!d) return '';
  const x = new Date(d);
  if (isNaN(x.getTime())) return '';
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}T${pad(x.getHours())}:${pad(x.getMinutes())}`;
}

// ── Локализованные даты (по языку интерфейса) ────────────────────────────────
// Chrome не знает названия месяцев для узбекской локали (показывает «M09»),
// поэтому для uz названия берутся из таблиц ниже, для ru/en — из Intl.
const UZ = {
  uz: {
    monthsShort: ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avg', 'sen', 'okt', 'noy', 'dek'],
    monthsLong: ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun', 'iyul', 'avgust', 'sentabr', 'oktabr', 'noyabr', 'dekabr'],
    daysShort: ['yak', 'dush', 'sesh', 'chor', 'pay', 'jum', 'shan'],
    daysLong: ['yakshanba', 'dushanba', 'seshanba', 'chorshanba', 'payshanba', 'juma', 'shanba'],
  },
};
const INTL_LOCALE = { ru: 'ru-RU', en: 'en-GB', tr: 'tr-TR' };

export function appLang() {
  try { return localStorage.getItem('language') || 'uz'; } catch { return 'uz'; }
}

// Локаль для Intl (числа, время): uz → 'uz-UZ' (числа форматируются корректно).
export function appLocale() {
  return INTL_LOCALE[appLang()] || 'uz-UZ';
}

// opts как у toLocaleDateString: { weekday:'short'|'long', day:'numeric', month:'short'|'long', year:'numeric' }
export function localeDate(d, opts = { day: 'numeric', month: 'short' }) {
  const x = new Date(d);
  if (isNaN(x.getTime())) return '';
  const lang = appLang();
  const tbl = UZ[lang];
  if (!tbl) return x.toLocaleDateString(INTL_LOCALE[lang] || 'en-GB', opts);
  const parts = [];
  if (opts.day) parts.push(String(x.getDate()));
  if (opts.month === 'short') parts.push(tbl.monthsShort[x.getMonth()]);
  else if (opts.month === 'long') parts.push(tbl.monthsLong[x.getMonth()]);
  else if (opts.month) parts.push(String(x.getMonth() + 1).padStart(2, '0'));
  if (opts.year) parts.push(String(x.getFullYear()));
  let out = parts.join(' ');
  if (opts.weekday) {
    const w = (opts.weekday === 'long' ? tbl.daysLong : tbl.daysShort)[x.getDay()];
    out = out ? w + ', ' + out : w;
  }
  return out;
}

export function localeTime(d) {
  const x = new Date(d);
  if (isNaN(x.getTime())) return '';
  return x.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

// «Сегодня» → только время; иначе «10 сен, 17:08»
export function localeShortDateTime(d) {
  if (!d) return '';
  const x = new Date(d);
  if (isNaN(x.getTime())) return '';
  const diffDays = Math.floor((Date.now() - x) / 86400000);
  const time = localeTime(x);
  return diffDays === 0 ? time : localeDate(x, { day: 'numeric', month: 'short' }) + ', ' + time;
}
